<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>经营者收入申报</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">经营者收入申报</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item label="手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.phone"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="4">
                <el-form-item label="年份">
                  <div style="display: flex; align-items: center">
                    <el-select
                      v-model="ruleForm.year"
                      placeholder="选择年份"
                      style="margin-right: auto"
                    >
                      <el-option label="2025年" value="2025"></el-option>
                      <el-option label="2026年" value="2026"></el-option>
                      <el-option label="2027年" value="2027"></el-option>
                      <el-option label="2028年" value="2028"></el-option>
                      <el-option label="2029年" value="2029"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="月份">
                  <div style="display: flex; align-items: center">
                    <el-select
                      v-model="ruleForm.mounth"
                      placeholder="选择月份"
                      style="margin-right: auto"
                    >
                      <el-option label="1月" value="1"></el-option>
                      <el-option label="2月" value="2"></el-option>
                      <el-option label="3月" value="3"></el-option>
                      <el-option label="4月" value="4"></el-option>
                      <el-option label="5月" value="5"></el-option>
                      <el-option label="6月" value="6"></el-option>
                      <el-option label="7月" value="7"></el-option>
                      <el-option label="8月" value="8"></el-option>
                      <el-option label="9月" value="9"></el-option>
                      <el-option label="10月" value="10"></el-option>
                      <el-option label="11月" value="11"></el-option>
                      <el-option label="12月" value="12"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="待申报" value="0"></el-option>
                    <el-option label="已申报" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button type="primary" @click="getList('new')" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <div style="margin-bottom: 20px">
          <el-button type="primary" @click="InvoicingAll()" class="btn"
            >批量申报</el-button
          >
          <el-button type="primary" @click="dowon()" class="btn"
            >税务申报模板下载</el-button
          >
          <el-button type="primary" @click="exportList(2)" class="btn"
            >导出申报excel</el-button
          >
        </div>
        <TableScrollSlider :table-ref="$refs.multipleTable" />
        <el-table
          :data="tableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
          ref="multipleTable"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column
            prop="hasRegisterCert"
            label="是否已取得等级证照"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column prop="month" label="月份" align="center">
          </el-table-column>
          <el-table-column
            prop="memberName"
            label="(名称)姓名"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="licenseNo"
            label="统一社会信用代码(纳税人识别号)"
            align="center"
            width="170"
          >
          </el-table-column>
          <el-table-column
            prop="incomeFrom"
            label="收入来源的互联网平台名称"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="incomeCustomName"
            label="收入来源的店铺(用户)名称"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="incomeCustomId"
            label="收入来源的店铺(用户)唯一标识码"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="unRegisterCertCode"
            label="证件号码"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="saleGoodIncomeAmount"
            label="销售货品收入总额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="saleGoodRefundAmount"
            label="销售货品退款金额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="saleGoodNetAmount"
            label="销售货品收入净额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="saleIntangibleIncomeAmount"
            label="销售无形资产收入总额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="saleIntangibleRefundAmount"
            label="销售无形资产退款金额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="saleIntangibleNetAmount"
            label="销售无形资产收入净额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="saleServerIncomeAmount"
            label="销售服务收入总额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="saleServerRefundAmount"
            label="销售服务退款金额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="saleServerNetAmount"
            label="销售服务收入净额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="unregisterIncomeAmount"
            label="未登记收入总额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="unregisterRefundAmount"
            label="未登记退款金额"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="unregisterTotalAmount"
            label="未登记小计"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="saleGoodAmount"
            label="销售货物"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="transportService"
            label="运输服务"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="serviceRemuneration"
            label="劳务报酬"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="royalty" label="稿酬" align="center">
          </el-table-column>
          <el-table-column
            prop="franchiseFee"
            label="特许权使用费"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="networkNetIncome"
            label="从事其他网络交易活动取得的收入(净额)"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="paidToPlatform"
            label="支付给平台的佣金、服务费合计金额"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="orderNum"
            label="交易(订单)数量(笔)"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.status == 0">待申报</span>
              <span class="greenColor" v-if="scope.row.status == 1"
                >已申报</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="120"
          >
            <template slot-scope="scope">
              <div class="disAround" v-if="scope.row.status == 0">
                <div class="operateBtn" @click="Invoicing(scope.row)">
                  提交申报
                </div>
              </div>
              <div class="operateBtn" @click="goDetail(scope.row)">
                查看明细
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible1"
      width="40%"
      :before-close="handleClose1"
    >
      <div style="height: 350px; overflow-y: scroll">
        <div v-for="(item, index) in errorList" :key="index">{{ item }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible1 = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.taxData(),
      ruleForm: {
        name: "",
        status: "",
        phone: "",
        mounth: "",
        year: "2025",
      },
      tableData: [],
      errorList: [],
      page: 1,
      pageSize: 20,
      total: 0,
      multipleTable: [],
      failDesc: "",
      dialogVisible1: false,
      selectData: {},
      status: "",
      type: "0", //0 单独数据处理   1批量数据确认
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    goDetail(val) {
      this.$router.push({
        path: "/platformOperationDetail",
        query: {
          id: val.managerDeclarationNo,
        },
      });
    },
    dowon() {
      window.open(
        "http://down.baoanlailou.com/file/excel/template-平台内的经营者和从业人员收入信息报送表.xls"
      );
    },
    handleClose() {
      this.dialogVisible = false;
      this.status = "";
      this.failDesc = "";
    },
    handleClose1() {
      this.dialogVisible1 = false;
    },
    exportList() {
      if (this.mounth == "") {
        this.$message({
          message: "请选择季度",
          type: "warning",
        });
        return;
      }
      let arr = [];
      if (this.multipleTable.length != 0) {
        for (var i = 0; i < this.multipleTable.length; i++) {
          arr.push(this.multipleTable[i].id);
        }
      }
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.ruleForm.name,
        year: this.ruleForm.year,
        month: this.ruleForm.mounth,
        isDeclare: this.ruleForm.status,
        ids: arr,
      };
      let str = "/admapi/tax/manager/declare/export";
      this.$axios
        .post(str, param, { responseType: "blob" })
        .then((data) => {
          console.log(data);
          this.$refs.multipleTable.clearSelection();
          let val = new Blob([data.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
          });
          let header = decodeURI(data.headers["content-disposition"]);
          // console.log(header);
          let index = header.indexOf("''");
          let fileName = header.substring(index + 2, header.length);
          console.log(fileName);
          const url = window.URL.createObjectURL(val);
          const link = document.createElement("a");
          link.download = fileName; // 设置a标签的下载属性
          link.style.display = "none";
          link.href = url;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href); // 下载完成释放URL 对象
          document.body.removeChild(link);
        })
        .catch()
        .finally();
      // );
    },
    InvoicingAll() {
      this.$confirm("是否批量提交申报", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.multipleTable.length == 0) {
            this.$message({
              message: "请选择确认数据",
              type: "warning",
            });
            return;
          }
          let arr = [];
          for (var i = 0; i < this.multipleTable.length; i++) {
            arr.push(this.multipleTable[i].id);
          }
          let param = {
            ids: arr,
          };
          this.$axios
            .post(`/admapi/tax/manager/declare/batchsubmit`, param)
            .then(({ data }) => {
              this.$message({
                message: "批量申报成功",
                type: "success",
              });
              this.multipleTable = [];
              this.$refs.multipleTable.clearSelection();
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    Invoicing(val) {
      this.selectData = val;
      this.$confirm("是否确认提交申报", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: this.selectData.id,
          };
          this.$axios
            .post(`/admapi/tax/manager/declare/submit`, param)
            .then(({ data }) => {
              this.$message({
                message: "申报成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleTable = val;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.ruleForm.phone = "";
      this.ruleForm.mounth = "";
      this.ruleForm.id = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList(val) {
      if (val == "new") {
        this.page = 1;
      }
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.ruleForm.name,
        year: this.ruleForm.year,
        month: this.ruleForm.mounth,
        status: this.ruleForm.status,
      };

      this.$axios
        .post(`/admapi/tax/manager/declare/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style>
.el-popover {
  padding: 0px 16px !important;
  box-sizing: border-box;
  border: none;
  min-width: 0;
}
</style>
